<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("gym income") }}
      </h1>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("date range") }}</label>
          <generic-calendar
            type="date"
            :is_range="true"
            ref="generic_calendar"
            @selected="date_changed"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("query") }}</label>
          <div class="control">
            <button class="button is-rounded is-primary" @click="query">
              <span class="icon"><i class="fa fa-bolt"></i></span>
              <span>{{ $t("query") }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="tabs is-toggle is-fullwidth" ref="tabs">
      <ul>
        <li
          class="is-active"
          data-tab="sales"
          @click="change_active_tab($event, this)"
        >
          <a>
            <i class="money icon" aria-hidden="true"></i>
            <span>{{ $t("sales") }}</span>
          </a>
        </li>
        <li data-tab="promotions" @click="change_active_tab($event, this)">
          <a>
            <i class="image icon" aria-hidden="true"></i>
            <span>{{ $t("promotions") }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="is-fluid" ref="contents">
      <div class="" data-tab="sales">
        <div class="container">
          <h1 class="title is-4 mb-3">
            {{ $t("total sold") }}: {{ format_currency(total_sold) }}
          </h1>
          <div>
            <!-- <pre>{{ sales }}</pre> -->
            <h1 class="title is-4 mb-6">
              <span
                class="pr-4"
                v-for="(p, pidx) in Object.keys(payment_summary)"
                :key="pidx"
              >
                {{ p }}: {{ format_currency(payment_summary[p]) }}
              </span>
            </h1>
            <!-- <pre>{{ payment_summary }}</pre> -->
            <div v-for="(sale, sidx) in sales" :key="sidx" class="mb-6">
              <div class="columns">
                <div class="column">
                  <h1 class="title is-5 mb-3">
                    {{ $t("sale") }}: {{ format_date_time(sale.create_date) }}
                  </h1>
                </div>
                <div class="column">
                  <h1 class="title is-5 mb-3">
                    {{ $t("total") }}: {{ format_currency(sale.total) }}
                  </h1>
                </div>
                <div class="column">
                  <h1 class="title is-5 mb-3">
                    <span
                      class="pr-4"
                      v-for="(p, pidx) in sale.payment"
                      :key="pidx"
                    >
                      {{ p.name }}: {{ format_currency(p.amount) }}
                    </span>
                  </h1>
                </div>
                <div class="column" v-if="sale.bill">
                  <h1 class="title is-5 mb-3">
                    <span>
                      {{ $t("authorization") }}: {{ $t("series") }}
                      {{
                        sale.bill.response_data["dte:GTDocumento"][
                          "dte:SAT"
                        ][0]["dte:DTE"][0]["dte:Certificacion"][0][
                          "dte:NumeroAutorizacion"
                        ][0]["$"].Serie
                      }}, {{ $t("number") }}
                      {{
                        sale.bill.response_data["dte:GTDocumento"][
                          "dte:SAT"
                        ][0]["dte:DTE"][0]["dte:Certificacion"][0][
                          "dte:NumeroAutorizacion"
                        ][0]["$"].Numero
                      }}
                    </span>
                  </h1>
                </div>
              </div>
              <table class="table is-fullwidth">
                <thead>
                  <tr>
                    <th>{{ $t("product") }}</th>
                    <th>{{ $t("sale price") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(sp, spidx) in sale.sale_products" :key="spidx">
                    <td>{{ sp.product ? sp.product.name : "" }}</td>
                    <td>{{ format_currency(sp.sale_price) }}</td>
                  </tr>
                </tbody>
              </table>
              <!-- <pre>{{ sale }}</pre> -->
            </div>
          </div>
        </div>
      </div>
      <div class="is-hidden" data-tab="promotions">
        <div class="container">
          <div class="title is-2">{{ $t("sold promotions") }}</div>
          <h1 class="title is-4 mb-3">
            {{ $t("total sold") }}: {{ format_currency(total_promotions_sold) }}
          </h1>
          <div>
            <h1 class="title is-5 mt-2 mb-6">
              <span
                class="pr-4"
                v-for="(p, pidx) in promotions_summary"
                :key="pidx"
              >
                {{ p.name }}: {{ format_currency(p.total) }}
              </span>
            </h1>
            <!-- <div v-for="(sale, sidx) in sold_promotions" :key="sidx" class="mb-6">
              <div class="columns">
                <div class="column">
                  <h1 class="title is-4 mb-3">
                    {{ $t("date") }}: {{ format_date_time(sale.create_date) }}
                  </h1>
                </div>
                <div class="column">
                  <h1 class="title is-4 mb-3">
                    {{ $t("total") }}: {{ format_currency(sale.promotion.settings.price) }}
                  </h1>
                </div>                
              </div> -->
            <table class="table is-fullwidth">
              <thead>
                <tr>
                  <th>{{ $t("date") }}</th>
                  <th>{{ $t("customer") }}</th>
                  <th>{{ $t("promotion") }}</th>
                  <th>{{ $t("sale price") }}</th>
                  <th>{{ $t("billing") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(sp, spidx) in sold_promotions" :key="spidx">
                  <td>{{ format_date(sp.create_date) }}</td>
                  <td>{{ sp.gym_member.name }}</td>
                  <td>{{ sp.promotion.name }}</td>
                  <td>{{ format_currency(sp.promotion.settings.price) }}</td>
                  <td>
                    <div v-if="sp.bill">
                      <!-- <span class="pr-4"
                        >{{ $t("name") }}: {{ sp.bill.name }}</span
                      >
                      <span class="pr-4"
                        >{{ $t("nit") }}: {{ sp.bill.nit }}</span
                      >
                      <span class="pr-4"
                        >{{ $t("total") }}:
                        {{ format_currency(sp.bill.total) }}</span
                      > -->
                      <span class="pr-4" v-if="sp.bill.response_data"
                        >{{ $t("authorization") }}: {{ $t("series") }}
                        {{
                          sp.bill.response_data["dte:GTDocumento"][
                            "dte:SAT"
                          ][0]["dte:DTE"][0]["dte:Certificacion"][0][
                            "dte:NumeroAutorizacion"
                          ][0]["$"].Serie
                        }}, {{ $t("number") }}
                        {{
                          sp.bill.response_data["dte:GTDocumento"][
                            "dte:SAT"
                          ][0]["dte:DTE"][0]["dte:Certificacion"][0][
                            "dte:NumeroAutorizacion"
                          ][0]["$"].Numero
                        }}</span
                      >
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- </div> -->
          </div>
        </div>
        <div class="container mt-4">
          <h1 class="title is-2">{{ $t("payments received") }}</h1>
          <h1 class="title is-4 mb-3">
            {{ $t("total received") }}:
            {{ format_currency(total_payments_received) }}
          </h1>
          <div>
            <h1 class="title is-5 mt-2 mb-6">
              <span
                class="pr-4"
                v-for="(p, pidx) in payments_summary"
                :key="pidx"
              >
                {{ p.name }}: {{ format_currency(p.total) }}
              </span>
            </h1>
            <table class="table is-fullwidth">
              <thead>
                <tr>
                  <th>{{ $t("date") }}</th>
                  <th>{{ $t("customer") }}</th>
                  <th>{{ $t("total") }}</th>
                  <th>{{ $t("payment detail") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(sp, spidx) in payments" :key="spidx">
                  <td>{{ format_date(sp.create_date) }}</td>
                  <td>{{ sp.gym_member.name }}</td>
                  <td>{{ format_currency(sp.total) }}</td>
                  <td>
                    <span
                      class="pr-4"
                      v-for="(pd, pdidx) in sp.payment_detail"
                      :key="pdidx"
                    >
                      {{ pd.payment_method }}: {{ format_currency(pd.amount) }}
                      <span v-if="pd.document_number"
                        >{{ $t("document number") }}:
                        {{ pd.document_number }}</span
                      >
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- </div> -->
          </div>
          <!-- <pre>{{ payments }}</pre> -->
        </div>
        <!-- <pre>{{ sold_promotions }}</pre> -->
      </div>
    </div>
  </section>
</template>

<script>
import {
  get,
  generate_datatables_buttons,
  error_message,
  put,
  del,
  confirm_deletion_dialog,
  success_message,
  format_date_time,
  format_date,
  format_time,
  format_currency,
  change_active_tab,
} from "@/utils";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import { groupBy } from "lodash";

export default {
  name: "SalesReport",
  components: { GenericTable, GenericCalendar },
  data() {
    let v = this;
    return {
      sales: [],
      meta: {
        start_date: "",
        end_date: "",
      },
      sold_promotions: [],
      payments: [],
    };
  },
  computed: {
    total_sold() {
      let v = this;
      let total = v.sales.reduce((acc, sale) => {
        return acc + Number(sale.total);
      }, 0);
      return total;
    },
    total_promotions_sold() {
      let v = this;
      let total = v.sold_promotions.reduce((acc, prmtn) => {
        return acc + Number(prmtn.promotion.settings.price);
      }, 0);
      return total;
    },
    promotions_summary() {
      let v = this;
      let grpd = groupBy(v.sold_promotions, (itm) => {
        return itm.promotion.name;
      });
      return Object.keys(grpd).map((k) => {
        return {
          name: k,
          total: grpd[k].reduce((acc, itm) => {
            return acc + Number(itm.promotion.settings.price);
          }, 0),
        };
      });
    },
    payment_summary() {
      let v = this;
      if (v.sales.length) {
        let summary = v.sales.reduce((acc, sale) => {
          let payment = sale.payment;
          payment.map((p) => {
            if (acc[p.name]) {
              acc[p.name] += Number(p.amount);
            } else {
              acc[p.name] = Number(p.amount);
            }
          });
          return acc;
        }, {});
        return summary;
      } else return {};
    },
    payments_summary() {
      let v = this;
      if (v.payments && v.payments.length) {
        let summary = v.payments.reduce((prev, curr) => {
          return prev.concat(curr.payment_detail);
        }, []);

        let grpd = groupBy(summary, (itm) => {
          return itm.payment_method;
        });
        return Object.keys(grpd).map((k) => {
          return {
            name: k,
            total: grpd[k].reduce((acc, itm) => {
              return acc + Number(itm.amount);
            }, 0),
          };
        });
      } else return [];
    },
    total_payments_received() {
      let v = this;
      let total = v.payments.reduce((acc, payment) => {
        return acc + Number(payment.total);
      }, 0);
      return total;
    },
  },
  methods: {
    change_active_tab,
    format_date_time,
    format_time,
    format_date,
    format_currency,
    query() {
      let v = this;
      get("/apis/gym_member/income", v.meta)
        .then((r) => {
          v.sales = r.sales;
          v.sold_promotions = r.promotions;
          v.payments = r.payments;
        })
        .catch((error) => {
          error_message(error);
        });
    },
    date_changed(date) {
      let v = this;
      v.meta.start_date = date.start_date;
      v.meta.end_date = date.end_date;
    },
  },
  mounted() {
    let v = this;

    // get("/apis/system/users", {})
    //   .then((r) => {
    //     v.users = r;

    //     setTimeout(() => {
    //       // // To access to bulmaCalendar instance of an element
    //       // var element = document.querySelector("#my-element");
    //       // if (element) {
    //       //   // bulmaCalendar instance is available as element.bulmaCalendar
    //       //   element.bulmaCalendar.on("select", function (datepicker) {
    //       //     console.log(datepicker.data.value());
    //       //   });
    //       // }
    //     }, 200);
    //   })
    //   .catch((error) => {
    //     error_message(error);
    //   });
  },
};
</script>

<style>
/* Add Bulma styles here */
</style>
